var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nda-article',{attrs:{"bannerSrc":_vm.isTenant ? require('../assets/panda/opciones.svg') : require('../assets/opciones.svg'),"description":_vm.description,"icon":_vm.icon,"image":_vm.image,"name":_vm.name,"sectionName":"Mi Plan"}})
}
var staticRenderFns = []

export { render, staticRenderFns }